function __match(v,ex){if(ex===null)return v===null;if(ex===undefined)return true;const t=typeof ex;if(t==='string'||t==='number'||t==='boolean')return typeof v===t;if(Array.isArray(ex)){if(!Array.isArray(v))return false;return ex.length?v.every(x=>__match(x,ex[0])):true}if(t==='object'){if(!v||typeof v!=='object'||Array.isArray(v))return false;return Object.keys(ex).every(k=>k in v&&__match(v[k],ex[k]))}return v===ex};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.__ex=ex;t.check=v=>__match(v,ex)}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type};
/* tjs <- deep-clone.ts */

import { XinObject, XinArray, AnyFunction } from './xin-types'

const Scalar = Type('Scalar')

const Cloneable = Type('Cloneable')

/* line 8 */
/* TODO: TS types degraded — obj: Cloneable, return: Cloneable | Cloneable[] */
export function deepClone(obj,seen) {
    if (obj == null || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof Date) {

        return new Date(obj.getTime());
    }
    if (seen === undefined) {
        seen = new WeakMap();
    }
    else if (seen.has(obj)) {
        return seen.get(obj);
    }
    if (obj instanceof Set) {
        const clone = new Set();
        seen.set(obj, clone);
        for (const item of obj) {
            clone.add(deepClone(item, seen));
        }
        return clone;
    }
    if (obj instanceof Map) {
        const clone = new Map();
        seen.set(obj, clone);
        for (const [key, value] of obj) {
            clone.set(deepClone(key, seen), deepClone(value, seen));
        }
        return clone;
    }
    if (Array.isArray(obj)) {
        const clone = [];
        seen.set(obj, clone);
        for (const item of obj) {
            clone.push(deepClone(item, seen));
        }
        return clone;
    }
    const clone = {};
    seen.set(obj, clone);
    for (const key in obj) {
        clone[key] = deepClone(obj[key], seen);
    }
    return clone;
}
deepClone.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "seen": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "any"
          },
          {
            "kind": "undefined"
          }
        ]
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "deep-clone.ts:11"
}